import React from 'react';
export const ThemeContext = React.createContext(
   {
      darkMode: localStorage.getItem('THEME') === 'true' || (!localStorage.getItem('THEME') && window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches),
      toggleTheme: () => { }
   }
);
